import useSWR from "swr";
import { MondayApiQueryInstance } from "../../../../services/monday/monday-service-ts";

/**
 * The pickers' choices, cached for the session so reopening an editor shows them at once and
 * refreshes in the background, instead of loading from scratch each time.
 */
const PICKER_SWR_OPTIONS = {
  revalidateOnFocus: false,
  dedupingInterval: 60_000,
  keepPreviousData: true,
};

export const boardTagsKey = (boardId: number) => ["item-view-board-tags", boardId] as const;

export const useBoardTags = (boardId: number) =>
  useSWR(boardTagsKey(boardId), () => MondayApiQueryInstance.getBoardTags(boardId), {
    ...PICKER_SWR_OPTIONS,
    keepPreviousData: false,
  });

/** Users only: listing teams needs the teams:read scope, which the app doesn't have yet. */
export const usePeopleSearch = (term: string) =>
  useSWR(
    ["item-view-people-search", term],
    () => MondayApiQueryInstance.searchPeople(term),
    PICKER_SWR_OPTIONS,
  );
